import { css, styled } from '@styles/theme'

export const CoursesStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',

		'&.AccordionTrigger': {
			color: 'red',
		},

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),
	titleIndex: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',

		marginTop: '24px',
		div: {
			display: 'flex',
			gap: '5px',
			marginTop: '10px',
			flexDirection: 'column-reverse',
		},

		'@md': {
			flexDirection: 'row',
			marginTop: '40px',
			div: {
				display: 'flex',
				gap: '28px',
				marginTop: '0px',
				flexDirection: 'row',
			},
		},
	}),

	title: css({
		fontSize: 18,
		color: '$neutral160',
		fontWeight: 500,
		'@md': {
			fontSize: 20,
		},
	}),
	myCourses: css({
		marginTop: 14,
		marginBottom: 28,
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(334px, 1fr))',
		gap: 16,

		'@md': {
			marginBottom: 48,
			gridTemplateColumns: 'repeat(2, minmax(502px, 1fr))',
			marginTop: 27,
			gap: 32,
		},
	}),
	myCoursesTitle: css({}),
	myOtherCourses: css({
		marginTop: 14,
		marginBottom: 32,
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(334px, 1fr))',
		gap: 32,

		'@md': {
			gridTemplateColumns: 'repeat(2, minmax(502px, 1fr))',
			marginTop: 27,
		},
	}),
	lastAccessContainer: css({
		marginBottom: 16,
		'@md': {
			marginBottom: '5rem',
		},
	}),
	paginationContainer: css({
		marginTop: 16,
		'@md': {
			marginTop: '10rem',
		},
	}),
	Line: styled('div', {
		width: '100%',
		height: '1px',
		background: '$neutral50',
	}),

	searchContainer: css({
		display: 'flex',
		marginTop: 35,
		justifyContent: 'space-between',
		flexDirection: 'column',
		gap: 10,
		'@md': {
			display: 'flex',
			flexDirection: 'row',
		},
	}),

	TabContainer: styled('div', {
		display: 'flex',
		gap: 32,
		marginTop: '24px',
		marginBottom: '24px',
		borderBottom: '1px solid #EDEEF3',
		position: 'relative',
		'@md': {
			marginTop: '34px',
		},
	}),

	TabItem: styled('div', {
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
		gap: 6,
		transition: 'all 0.2s ease-out',
		svg: {
			color: '$neutral70',
			width: 20,
			height: 20,
			'&.active': {
				color: '$blue20',
			},
		},

		paddingBottom: '10px',
		borderBottom: '2px solid transparent',

		'&.active': {
			borderBottomColor: '#29A0D2',
			position: 'relative',
		},
		'&.active::before': {
			content: '',
			position: 'absolute',
			bottom: '-2px',
			width: 'calc(100% + 18px)',
			borderBottom: '2px solid #29A0D2',
			transition: 'width 0.2s ease-out',
		},
	}),

	NotFound: styled('div', {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginTop: '7rem',
		marginBottom: '7rem',
		svg: {
			width: 26,
			height: 26,
			color: '$neutral90',
			marginBottom: 9,
		},

		'&.favorite': {
			marginTop: '72px',
		},
	}),
	showMyCoursesButton: css({
		display: 'flex',
		marginTop: 25,
		justifyContent: 'center',
		alignItems: 'center',
		padding: '14px 38px',
		color: '$neutral80',
		fontWeight: '$bold',
		fontSize: '18px',
		border: '1px solid',
		borderColor: '$neutral80',
		borderRadius: '14px',
		cursor: 'pointer',
	}),

	popupContainer: css({
		top: '50%',
		left: '50%',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.8)',
		padding: '0px',
		height: 'auto',
		width: 'min-content',
		minWidth: '40vh',
		minHeight: '40vh',

		'@lg': {
			minWidth: '50vh',
			minHeight: '50vh',
		},

		'@resp': {
			minWidth: '80vh',
			minHeight: '80vh',
		},
	}),

	popupImage: css({
		width: 'auto',
		height: 'auto',
		maxWidth: '100%',
		maxHeight: '100%',
		objectFit: 'contain',
	}),
}
